export { MetricsShowcaseSection as StarRatingSummarySection } from "../credibility-sections"
export type { MetricsShowcaseSectionProps as StarRatingSummarySectionProps } from "../credibility-sections"